import { render, staticRenderFns } from "./edit-media-modal.vue?vue&type=template&id=7b16bce6&scoped=true"
import script from "./edit-media-modal.vue?vue&type=script&lang=js"
export * from "./edit-media-modal.vue?vue&type=script&lang=js"
import style0 from "./edit-media-modal.vue?vue&type=style&index=0&id=7b16bce6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b16bce6",
  null
  
)

export default component.exports